import { Dialog, DialogActionsBar } from '@progress/kendo-react-dialogs';
import { Skeleton } from '@progress/kendo-react-indicators';
import { CardNumberElement, useElements, useStripe } from '@stripe/react-stripe-js';
import React, { useEffect, useRef, useState } from 'react';
import { callApiWithAuthorization } from '../../API/CallApi';
import { updateCustomerDefaultPaymentMethod } from '../../API/Payment/Payment';
import InnerLoader from '../Shared/Loader/InnerLoader';
import Loader from '../Shared/Loader/loader';
import { OverlayLoader } from '../Shared/Loader/OverlayLoader';
import BillingInformationForm from './BillingInformationForm';
import NewCardForm from './NewCardForm';

function AddNewCardDialog({ organizationId, customerId, onCreate, onClose }) {

    const stripe = useStripe();
    const elements = useElements();

    const formRef = useRef(null);

    const [loading, setLoading] = useState(true);
    const [setupIntent, setSetupIntent] = useState("");
    const [billingInformation, setBillingInformation] = useState({});

    const [cardInformationValid, setCardInformationValid] = useState(false);

    const [creatingCard, setCreatingCard] = useState(false);

    useEffect(() => {
        callApiWithAuthorization("/api/v0/payment/setup", {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                customerId
            })
        })
        .then(res => res.json())
        .then(({ clientSecret }) => setSetupIntent(clientSecret))
        .finally(() => setLoading(false))
        .catch(console.error);
    }, [])

    async function handleSubmit() {
        try {
            setCreatingCard(true);
            const { name, ...address } = billingInformation;
            const response = await stripe.confirmCardSetup(
                setupIntent,
                {
                    payment_method: {
                        card: elements.getElement(CardNumberElement),
                        billing_details: {
                            address,
                            name
                        }
                    }
                }
            )
            debugger
            if (response.setupIntent) {
                await updateCustomerDefaultPaymentMethod(
                    organizationId,
                    response.setupIntent.payment_method
                )
                onCreate(response.setupIntent);
            }
        } catch (e) {
            console.error(e);
        } finally {
            setCreatingCard(false);
        }
    }

    return (
        <Dialog
            title="Add new card"
            onClose={onClose}
            width={"30%"}>
            {
                loading &&
                <div className='container-fluid'>
                    <div className='row'>
                        <div className='col-12'>
                            <Skeleton
                                shape={"text"}
                                style={{
                                    width: "100%",
                                    height: 50,
                                    borderRadius: 10
                                }}
                            />
                        </div>
                        <div className='col-6'>
                            <Skeleton
                                shape={"text"}
                                style={{
                                    width: "100%",
                                    height: 50,
                                    borderRadius: 10
                                }}
                            />
                        </div>
                        <div className='col-6'>
                            <Skeleton
                                shape={"text"}
                                style={{
                                    width: "100%",
                                    height: 50,
                                    borderRadius: 10
                                }}
                            />
                        </div>
                        <div className='col-12'>
                            <Skeleton
                                shape={"rectangle"}
                                style={{
                                    width: "100%",
                                    height: 250,
                                    borderRadius: 10
                                }}
                            />
                        </div>
                    </div>
                </div>
            }
            {
                !loading &&
                <>
                    <NewCardForm
                        onChange={({ valid }) => {
                            setCardInformationValid(valid)
                        }} />
                    <div className='container-fluid'>
                        <div className='row mb-4 billing-info'>
                            <BillingInformationForm onChange={value => setBillingInformation(value)} />
                        </div>
                    </div>
                    <div className="border-top">
                        <div className="d-flex mt-3 container-fluid justify-content-spacing">
                            <div className="align-self-center">
                                <i className = "fa-solid fa-lock me-1"></i>
                                Secure Checkout
                            </div>
                            {/* <div className='d-flex text-center text-secure font-size-5'>
                                <div>
                                    <div>
                                        <i className='fa-solid fa-shield  p-1 border-secure rounded-circle' />
                                    </div>
                                    <span >
                                    SSL Protected
                                    </span>
                                </div>
                                <div className="mx-4">
                                    <div>
                                        <i className='fa-solid fa-globe  p-1 border-secure rounded-circle' />
                                    </div>
                                    <span>
                                        PCI Compliant
                                    </span>
                                </div>
                                <div>
                                    <div>
                                        <i className='fa-brands fa-expeditedssl  p-1 border-secure rounded-circle' />
                                    </div>
                                    <span>
                                        Encrypted
                                    </span>
                                </div>
                            </div> */}
                        </div>
                    </div>
                </>
            }
            {
                !loading &&
                <DialogActionsBar layout='end'>
                    <div className='d-flex py-3 px-2'>
                        <div style={{ width: "30px" }}>
                            {
                                creatingCard &&
                                <InnerLoader borderColor="green" />
                            }
                        </div>
                        <button
                            onClick={handleSubmit} className='btn btn-primary' disabled={!cardInformationValid}>
                            Add new card
                        </button>
                    </div>
                </DialogActionsBar>
            }
            {
                creatingCard &&
                <OverlayLoader />
            }
        </Dialog>
    )
}

export default AddNewCardDialog;